module.exports = __webpack_public_path__ + "static/media/nature.bb4d8703.jpeg";